import { z } from 'zod';

import { AstroSmartLinkVariant } from '@/generated/gql/graphql';

export const smartLinkGridFormSchema = z.object({
  id: z.string(),
  sequence: z.number(),
  title: z.string().min(1).prefault(''),
  description: z.string().optional(),
  url: z.url().min(1).prefault(''),
  hidden: z.boolean().prefault(false),
  external: z.boolean().prefault(false),
  variant: z.enum(AstroSmartLinkVariant).prefault(AstroSmartLinkVariant.OTHER),
});

export type SmartLinkGridFormSchema = z.infer<typeof smartLinkGridFormSchema>;
